<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <nx-bform-input
      :name="name"
        :rules="{ required, regex: /^[a-zA-Z0-9\_]*$/}"
      :value="$attrs.value"
      @input="$listeners.input"
    />
    <template #description>
      <RegistrationLoginNameNewFormDescription />
    </template>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";
import { UserApi } from "nx-libs";
import RegistrationLoginNameNewFormDescription from "./RegistrationLoginNameNewFormDescription";

export default {
  mixins: [FormGroupMixin],
  components: {
    RegistrationLoginNameNewFormDescription
  },
  computed: {
    name() {
      return this.label || this.$t("loginName");
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
